import {Component, Input} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';

@Component({
  selector: 'dcp-lead-form-error',
  templateUrl: './lead-form-error.component.html',
})
export class LeadFormErrorComponent {
  @Input() response: HttpErrorResponse;

  constructor(
    private readonly supportForm: DcpSupportFormService
  ) {
  }

  openContactSupport(): void {
    this.supportForm.open();
  }
}
